import * as React from 'react';
import Link from '@mui/material/Link';


export const honeyfundLink: string = "https://www.honeyfund.com/site/noyes-todd-05-10-2025";

type HoneyfundLinkProps = {
  linkText?: string,
  underline?: "hover" | "always" | "none"
};

const defaultProps: HoneyfundLinkProps = {
  linkText: "Honeyfund Registry",
  underline: "hover"
};

export default function HoneyfundLink(linkProps: HoneyfundLinkProps = defaultProps) {
  return (
          <Link href={honeyfundLink} 
            underline={linkProps.underline ? linkProps.underline : defaultProps.underline}
            >
            {linkProps.linkText ? linkProps.linkText : defaultProps.linkText}
          </Link>
  );
}